import React, { useState ,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import { FaMobileAlt } from "react-icons/fa";
import InputField from "../ResuableCompoment/InputField";
import useApi from "../CustomHooks/useApi";
import logo from "../Assest/Logo/logo_png_with_shreebalajee (1).png";
import { useDispatch } from "react-redux";
import { login } from "../../Store/Slices/AuthSlice";
import { logout } from "../../Store/Slices/AuthSlice"; 

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mobileNumber, setmobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  // const { callApi, loading } = useApi("/staff/onboard/signin", "POST", false);
  const { callApi, loading } = useApi("/staff/onboard/signin", "POST","DEFAULT", false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await callApi({
        mobile_number: mobileNumber,
        password,
      });
      if (data) {
        localStorage.setItem("token", data.token || "logged_in");
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("lastActivity", Date.now());
        dispatch(login(data));
        if (data.role === "COMPLIANCE") {
          navigate("/kycdashboard");
        } else if (
          data.role === "ONBOARDING" ||
          data.role === "SUPER_ONBOARDING"
        ) {
          navigate("/totalcount");
        } else if (data.role === "AEPS_BACKEND") {
          navigate("/aespdashboard");
        } else if (data.role === "NATIONAL_HEAD") {
          navigate("/rbdashboard")
        } else if (data.role === "ZONAL_HEAD") {
          navigate("/zhdashboard")
        } else if (data.role === "REGIONAL_SALES_MANAGER") {
          navigate("/rsmdashboard")
        } else if (data.role === "STATE_HEAD") {
          navigate("/shdashboard")
        } else if (data.role === "ASM") {
          navigate("/asmdashboard")
        } else if (data.role === "PAYOUT_ACCOUNTING"){
          navigate("/payoutdashboard")
        } else if (data.role === "HELPDESK_MANAGER") {
          navigate("/accountdashboard")
        } else if (data.role === "CASH_IN_MANAGER"){
          navigate("/accountingroledashboard")
        }
        else {
          setError("Unauthorized role access");
        }
      } else {
        setError("Invalid response from server");
      }
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  // added this below useEffect to clear localStorage and sessionStorage on component mount

  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("lastActivity");
    sessionStorage.clear();

    dispatch(logout()); 
  }, [dispatch]); 

  return (
    <div className="min-h-screen bg-[#F5F8FC] flex items-center justify-center px-4 sm:px-6 lg:px-12">
      <div className="w-full max-w-[95%] sm:max-w-3xl lg:max-w-5xl 2xl:max-w-6xl grid grid-cols-1 lg:grid-cols-2 bg-white rounded-3xl shadow-2xl overflow-hidden">

        {/* Left Side */}
        {/* <div className="bg-gradient-to-br from-[#F2F4F8] via-[#E8ECF3] to-[#DDE5F1]
     p-6 sm:p-10 lg:p-14 flex flex-col justify-center items-center text-[#0A2A4F]">

          <img
            src={logo}
            alt="Bingo Pay"
          className="h-[90px] sm:h-[120px] lg:h-[150px] w-auto object-contain mb-4"
          />
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0A2A4F] text-center">
  Welcome Back!
</h2>

         <p className="text-gray-600 text-center text-sm sm:text-base lg:text-lg mt-2">
  Access your staff dashboard securely
</p>

          <div className="hidden sm:block mt-10 space-y-4 w-full max-w-sm">
            {["Secure Access", "Fast & Reliable"].map((title, i) => (
              <div key={i} className="flex items-start space-x-3">
                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
                  ✓
                </div>
                <div>
                  <h3 className="font-semibold">{title}</h3>
                  <p className="text-sm text-blue-100">
                    Enterprise-grade platform
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <div className="bg-gradient-to-br from-[#F2F4F8] via-[#E8ECF3] to-[#DDE5F1]
     p-6 sm:p-10 lg:p-14 flex flex-col justify-center items-center text-[#0A2A4F]">

          <img
            src={logo}
            alt="Bingo Pay"
            className="h-[90px] sm:h-[120px] lg:h-[150px] w-auto object-contain mb-4"
          />

          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center">
            Welcome Back!
          </h2>

          <p className="text-gray-600 text-center text-sm sm:text-base lg:text-lg mt-2">
            Access your staff dashboard securely
          </p>

          <div className="hidden sm:block mt-10 space-y-4 w-full max-w-sm">
            {["Secure Access", "Fast & Reliable"].map((title, i) => (
              <div key={i} className="flex items-start space-x-3">
                <div className="w-8 h-8 rounded-full bg-[#D4AF37] flex items-center justify-center text-white font-bold">
                  ✓
                </div>
                <div>
                  <h3 className="font-semibold">{title}</h3>
                  <p className="text-sm text-gray-600">
                    Enterprise-grade platform
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>


        {/* Right Side */}
        <div className="bg-gradient-to-br from-[#F2F4F8] via-[#E8ECF3] to-[#DDE5F1]
     p-6 sm:p-8 lg:p-12 flex flex-col justify-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-[#0A2A4F]">
            Staff Login
          </h1>
          <p className="text-gray-600 text-sm sm:text-base mb-6">
            Please enter your credentials
          </p>
          <div className="bg-white/80 backdrop-blur-xl p-6 sm:p-8 rounded-2xl shadow-lg">
            <form onSubmit={handleLogin} className="space-y-5">
              <InputField
                type="text"
                icon={FaMobileAlt}
                inputMode="numeric"
                value={mobileNumber}
                onChange={(e) => setmobileNumber(e.target.value)}
                placeholder="Enter mobile number"
              />

              <InputField
                type="password"
                icon={FiLock}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />

              {error && (
                <div className="bg-red-50 border-l-4 border-red-500 p-3 rounded text-sm text-red-700">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#0A2A4F] hover:bg-[#08305F] text-white font-bold py-3 sm:py-4 rounded-xl transition disabled:opacity-50"
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>
          </div>
          <p className="text-center text-gray-400 text-xs mt-6">
            © 2026 Bingo Pay. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
